var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.11925e-07 10.3236C0.268 10.6164 0.533601 10.9124 0.804001 11.2026C1.0544 11.4703 1.3112 11.7322 1.5592 11.9916C1.5832 11.9916 1.5968 11.9916 1.6104 11.9916C1.624 11.9916 1.6392 11.9916 1.6464 11.9832C4.0984 9.42881 6.5488 6.87439 9.0296 4.28828L16.428 11.9999C16.4944 11.9324 16.576 11.8473 16.6592 11.7631L18 10.407L18 10.2402C17.9016 10.1518 17.7976 10.0735 17.7064 9.97422C14.8035 6.95028 11.9013 3.92551 9 0.899902C6.09813 3.9244 3.196 6.94917 0.2936 9.97422C0.2024 10.0693 0.0984004 10.1519 4.0828e-07 10.2402L4.11925e-07 10.3236Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.4945f0a41743bd68ddadee422d9eae5d.svg";
export { ForwardRef as ReactComponent };